export const periodObject = [
  { label: 'alarms.periods.last_8_hours', value: 'PERIOD_TYPE_LAST_8_HOURS' },
  { label: 'alarms.periods.last_24_hours', value: 'PERIOD_TYPE_LAST_24_HOURS' },
  { label: 'alarms.periods.last_week_days', value: `PERIOD_TYPE_LAST_WEEK_DAYS` }
];
